<h2 mat-dialog-title>Not Logged In</h2>
<mat-dialog-content class="mat-typography">
    <p>
      You must log in before contributing.
    </p>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Continue</button>
</mat-dialog-actions>